module.exports = __webpack_public_path__ + "img/smart-logo.2078581f.svg";